import '../assets/NcMentionBubble-CaztX9Pv.css';
import '../assets/NcAppNavigationSettings-2Wh1E3Hq.css';
import { i as mdiCogOutline, j as mdiCog } from "./mdi-CgetWrFc.mjs";
import { vOnClickOutside } from "@vueuse/components";
import { N as NcButton } from "./NcButton-Dz2O6cSU.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
import { r as register, o as t48, a as t } from "./_l10n-D3tJt_gL.mjs";
import clickOutsideOptions from "../Mixins/clickOutsideOptions.mjs";
import "../Composables/useIsFullscreen.mjs";
import "../Composables/useIsMobile.mjs";
import "escape-html";
import "striptags";
import "vue";
import "../Composables/useIsDarkTheme.mjs";
import "@nextcloud/router";
import "../Functions/isDarkTheme.mjs";
/* empty css                                                                          */
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
import "@nextcloud/auth";
import "@nextcloud/axios";
import "@nextcloud/capabilities";
import "./logger-D3RVzcfQ.mjs";
import { G as GenRandomId } from "./GenRandomId-F5ebeBB_.mjs";
import { i as isLegacy32 } from "./legacy-MK4GvP26.mjs";
register(t48);
const _sfc_main = {
  directives: {
    ClickOutside: vOnClickOutside
  },
  components: {
    NcButton,
    NcIconSvgWrapper
  },
  mixins: [
    clickOutsideOptions
  ],
  props: {
    /**
     * Text of the button
     *
     * @default 'Settings'
     */
    name: {
      type: String,
      required: false,
      default: t("Settings")
    }
  },
  setup() {
    const contentId = GenRandomId();
    return {
      contentId,
      isLegacy32,
      mdiCog,
      mdiCogOutline
    };
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    clickOutsideConfig() {
      return [
        this.closeMenu,
        this.clickOutsideOptions
      ];
    }
  },
  methods: {
    closeMenu() {
      this.open = false;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: _vm.clickOutsideConfig, expression: "clickOutsideConfig" }], class: { open: _vm.open }, attrs: { "id": "app-settings" } }, [_c("div", { attrs: { "id": "app-settings__header" } }, [_c("NcButton", { staticClass: "settings-button", attrs: { "aria-controls": _vm.contentId, "aria-expanded": _vm.open ? "true" : "false", "alignment": "start", "variant": "tertiary", "wide": "" }, on: { "click": function($event) {
    _vm.open = !_vm.open;
  } }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_c("NcIconSvgWrapper", { staticClass: "settings-button__icon", attrs: { "path": _vm.isLegacy32 ? _vm.mdiCog : _vm.mdiCogOutline } })];
  }, proxy: true }]) }, [_vm._v(" " + _vm._s(_vm.name) + " ")])], 1), _c("Transition", { attrs: { "name": "slide-up" } }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.open, expression: "open" }], attrs: { "id": _vm.contentId } }, [_vm._t("default")], 2)])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8fb21c8b"
);
const NcAppNavigationSettings = __component__.exports;
export {
  NcAppNavigationSettings as N
};
//# sourceMappingURL=NcAppNavigationSettings-Ba8OcJxl.mjs.map
